export default {
    TESTE_RAPIDO_DE_DENGUE_NS1: '0214010147'
}